<div class="table-responsive">
  <table class="table">
    <tbody>
      <tr *ngFor="let item of mappedData">
        <td style="width: 125px">
          <img
            class="img-fluid"
            *ngIf="
              item.product.productType === 'singleDimension'
                ? item.product.extra.images && item.product.extra.images[0]
                : item.product.images && item.product.images[0] as image;
              else noimage
            "
            src="https://cdn1.gung.io/fit-in/125x125/filters:fill(white):background_color(white):etag({{
              image.s3ETag
            }}):format(jpeg)/{{ image.s3Uri }}"
            alt=""
          />
          <ng-template #noimage>
            <img
              class="card-img-top img-fluid w-100"
              src="https://cdn1.gung.io/fit-in/125x125/images/no-image.jpg"
              alt="NO IMAGE"
              class="img-fluid mx-auto d-block"
            />
          </ng-template>
        </td>
        <td *ngIf="item.replacementId == null">
          <a
            (click)="
              item.product.productType === 'singleDimension'
                ? goToDetail(item.product)
                : goToDetailConcept(item.product)
            "
            class="text-dark"
          >
            <b>{{ item.id }}</b> - {{ item.name }}
          </a>
          <div class="small">{{ item.product.extra.ar?.artbeskrspec }}</div>
          <pre class="d-none">{{ item.product.extra.ar | json }}</pre>
          <p class="mt-2">
            <span class="d-block">{{ getProductSubTitle(item.product) | async }}</span>
            <span class="d-block"
              >{{ getOptionName('atp4', 'itemtypedesc', item.product.extra.ar?.itemtypecd4) }}
              <!-- Only if q_reg is defined -->
              <!-- Intentionally != instead of !== -->
              <!-- <span *ngIf="item.product.extra.ar?.q_reg!=null">
                <span translate>RETHREADED</span>:
                {{ getOptionName('q_reg', 'q_regdesc', item.product.extra.ar?.q_reg) }}
              </span> -->
              <span *ngIf="item.product.extra.ar?.q_klassid != null">
                <span translate>CLASS</span>:
                {{ getOptionName('q_klass', 'q_klassdesc', item.product.extra.ar?.q_klassid) }}
              </span>
            </span>

            <span
              class="d-block"
              *ngIf="
                !!item.product.extra.ar?.q_bransleeff &&
                !!item.product.extra.ar?.q_vatgrepp &&
                !!item.product.extra.ar?.q_bullervarde &&
                !!item.product.extra.ar?.q_bullerklass
              "
            >
              <span class="font-weight-bold" translate>EU_LABELING</span>:
              <span>{{ getOptionName('q_bransleeff', 'q_bransleeffdesc', item.product.extra.ar?.q_bransleeff) }}/</span>
              <span>{{ getOptionName('q_vatgrepp', 'q_vatgreppdesc', item.product.extra.ar?.q_vatgrepp) }}/</span>
              <span
                >{{ getOptionName('q_bullervarde', 'q_bullervardedesc', item.product.extra.ar?.q_bullervarde) }}/</span
              >
              <span>{{
                getOptionName('q_bullerklass', 'q_bullerklassdesc', item.product.extra.ar?.q_bullerklass)
              }}</span>
            </span>
            <span class="d-block">{{ getProductDescription(item.product) | async }}</span>
          </p>
          <colmec-product-symbols [product]="item.product"></colmec-product-symbols>

          <!-- Pristexten "Pris exklusive stomme" längst ned ska bara visas om varugruppkod=10 -->
          <!-- <p *ngIf="item.product.extra.ar?.varugruppkod==='10'" translate>PRICE_EXCLUSIVE_FRAME</p> -->
        </td>
        <td *ngIf="item.replacementId != null">
          <span [ngbPopover]="popContent2" triggers="mouseenter" [autoClose]="'outside'">
            <a routerLink="/product/{{ item.id }}" class="text-red">
              {{ item.id }} <i class="fas fa-exclamation-triangle"></i>
            </a>
          </span>
          <ng-template #popContent2>
            <div class="row">
              <div class="col text-center">
                <span translate>PRODUCT_REPLACED_BY</span> <br />
                <a routerLink="/product/{{ item.id }}" class="text-dark">
                  {{ item.replacementId }}
                </a>
              </div>
            </div>
          </ng-template>
        </td>
        <td>
          <span *ngIf="item.price">
            <div *ngIf="item.price.customerGrossPrice.value != item.price.customerNetPrice.value">
              <div class="pb-1" translate>
                <span translate>GROSS_PRICE</span>:&nbsp;{{
                  item.price.customerGrossPrice.value | gungCurrency: item.price.customerGrossPrice.currencyCode
                }}
              </div>
              <div class="pb-1" translate>
                DISCOUNT
                <span *ngIf="item.price.customerDiscountPercent !== 0"
                  >:&nbsp;(-{{ item.price.customerDiscountPercent }}%)</span
                >
              </div>
            </div>

            <div class="pb-2" [class.d-none]="hidePrice">
              {{ getNetPriceLabel(item.product) | async }}:&nbsp;{{
                getNetPriceValue(item.price) | gungCurrency: item.price.customerNetPrice.currencyCode
              }}
            </div>
          </span>

          <i class="fas fa-box product-availability-box-icon"></i>&nbsp;
          <lib-availability [availability]="item.availability" *ngIf="item.availability"></lib-availability>
        </td>
        <td class="buy-btn-product-table">
          <colmec-buy-btn
            *ngIf="item.product.productType === 'singleDimension'; else conceptButton"
            [product]="item.product"
            [id]="item.id"
            [minimumOrderQuantity]="item.packageSize"
            [stepAmount]="item.packageSize"
          >
          </colmec-buy-btn>
          <ng-template #conceptButton>
            <button
              type="button"
              class="btn btn-primary btn-sm go-to-product"
              (click)="goToDetailConcept(item.product)"
              translate
            >
              SEE_PRICE_PER
            </button>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
</div>
